// extracted by mini-css-extract-plugin
export default {"modCarpet":"FlooringMenu_modCarpet__a2E0o","mainMenu":"FlooringMenu_mainMenu__KiULU","activeMenuTab":"FlooringMenu_activeMenuTab__Rw-ob"};